
// Captalize the first letter of each word in a string
export const capitalizeWords = (str) => {
    if (!str) return '';
    return str
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, m => m.toUpperCase());
};

export const convertToArabicNumbers = (phoneNumber) => {
    const arabicNumerals = {
        '0': '٠',
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩'
    };

    return phoneNumber.split('').map(char => arabicNumerals[char] || char).join('');
}

export const formatPrice = (amount, lang = "en", currency = "$") => {
    if (!amount) {
        return `$0.00`;
    }

    let validAmount = parseFloat(amount);

    if (isNaN(validAmount)) {
        validAmount = 0;
    }

    let formattedAmount = validAmount
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (lang === "ar") {
        return `${convertToArabicNumbers(formattedAmount)}$`;
    }

    return `$${formattedAmount}`;
};

// Sale and refund amounts arrive in integer cents; wallet amounts in dollars.
export const formatCents = (cents) => formatPrice((Number(cents) || 0) / 100);

// Accepts an ISO string, a Date, a Firestore Timestamp or a serialized one ({ _seconds }).
export const toDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value.toDate === 'function') return value.toDate();
    const seconds = value._seconds ?? value.seconds;
    if (seconds !== undefined) return new Date(seconds * 1000);
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateTime = (value) => {
    const date = toDate(value);
    if (!date) return '—';
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

// Short distance from now like "5 min", "3 h", "2 d" (past or future).
export const timeAgo = (value) => {
    const date = toDate(value);
    if (!date) return '—';
    const minutes = Math.round(Math.abs(Date.now() - date.getTime()) / 60000);
    if (minutes < 60) return `${minutes} min`;
    const hours = Math.round(minutes / 60);
    if (hours < 24) return `${hours} h`;
    return `${Math.round(hours / 24)} d`;
};

export const fullName = (user, fallback = 'No Name') =>
    `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || fallback;

export const getInitials = (firstName, lastName, fallback = 'U') =>
    ((firstName?.charAt(0) || '') + (lastName?.charAt(0) || '')).toUpperCase() || fallback;

// Artist plan tiers (artist_payout_bps / 100 = payout %).
export const TIER_LABELS = {
    tier80: 'Starter Plan',
    tier90: 'Pro',
    tier100: 'Elite',
};

export const paymentMethods = [
    { label: 'Cash App', value: 'Cash App' },
    { label: 'Zelle', value: 'Zelle' },
    // { label: 'Bank Transfer', value: 'Bank Transfer' },
    { label: 'PayPal', value: 'PayPal' },
    { label: 'Venmo', value: 'Venmo' },
];